
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/posthog",
      function () {
        return require("private-next-pages/destinations/posthog.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/posthog"])
      });
    }
  